import { render, staticRenderFns } from "./OurRangeElectric.vue?vue&type=template&id=85774442"
import script from "./OurRangeElectric.vue?vue&type=script&lang=js"
export * from "./OurRangeElectric.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports